"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";

export default function projectPlanFundByYearTable() {
  return {
    restrict: "A",
    template: require("../view/table.html"),
    transclude: false,
    scope: {
      selectedItem: "=?myValue",
      items: "=?myItems",
      type: "@myType",
      filters: "=?myFilters",
      ok: "=?myOk",
      isPaging: "=myPagination",
      isSearch: "=mySearching",
      isFilter: "=myFilter",
      project: "=myProject",
      edit: "=edit",
      changed: "=?myChanged",
    },
    controller: [
      "$scope",
      "$routeParams",
      "$utils",
      "$uibModal",
      function ($scope, $routeParams, $utils, $modal) {
        $scope.getTotal = getTotal;
        $scope.dblClick = dblClick;
        $scope.select = select;
        $scope.isSelect = isSelect;
        $scope.getItems = getItems;
        $scope.getValue = $utils.getValue;
        $scope.refresh = refresh;

        if (!$scope.selectedItem) {
          $scope.selectedItem = {};
        }

        console.log("коммон", $scope);

        function getTotalWorkplaces() {
          return (
            Math.round(
              ($scope.project.projectPlanFundsByYear || []).reduce(
                (acc, value) => acc + (value.outputTotalWorkPlaces || 0),
                0
              ) * 100
            ) / 100
          );
        }
        $scope.restWorkplaces = function () {
          return Math.max(
            ($scope.project.profitPlanWplaces || 0) - getTotalWorkplaces(),
            0
          );
        };

        $scope.getHeaderValue = (name, type) => {
          if (type === "outputTotalWorkPlaces") {
            return `${name} (Не распределено: ${$scope.restWorkplaces()})`;
          }
          return name;
        };

        $scope.toggleTooltip = (column) => {
          $scope.columns = $scope.columns.map((col) => {
            if (col.name === column.name) {
              col.showTooltip = !col.showTooltip;
            }
            return col;
          });
        };

        $scope.getTableValues = (columnName, value) => {
          if (
            columnName === "municipalBudget" ||
            columnName === "localBudget" ||
            columnName === "ownBudget" ||
            columnName === "investorBudget" ||
            columnName === "federalBudget" ||
            columnName === "outputTotalCost" ||
            columnName === "tradeTurnover" ||
            columnName === "serviceCost" ||
            columnName === "outputTotalWorkPlaces"
          ) {
            return ranksDivider(value);
          } else {
            return value;
          }
        };

        $scope.headerBottomColumns = [
          {
            name: "Год",
            data: "year",
          },
          {
            name: "Собственные средства, млн. руб.",
            data: "ownBudget",
            width: "25%",
          },
          {
            name: "Привлеченные средства, млн. руб.",
            data: "investorBudget",
            width: "25%",
            showTooltip: false,
            tooltipText:
              "Привлеченные средства, в том числе банковские кредиты, иные заемные и привлеченные средства",
          },
          {
            name: "Объем отгруженной продукции, млн. руб.",
            data: "outputTotalCost",
          },
          {
            name: "Объем товарооборота, млн. руб.",
            data: "tradeTurnover",
          },
          {
            name: "Объем платных услуг (выполненных работ), млн. руб.",
            data: "serviceCost",
          },
          {
            name: "Новые рабочие места, чел.",
            data: "outputTotalWorkPlaces",
            type: "outputTotalWorkPlaces",
          },
        ];

        $scope.columns = [
          {
            name: "Год",
            data: "year",
          },
          {
            name: "Областной бюджет, млн. руб.",
            data: "municipalBudget",
            width: "25%",
          },
          {
            name: "Местный бюджет, млн. руб.",
            data: "localBudget",
            width: "25%",
          },
          {
            name: "Собственные средства, млн. руб.",
            data: "ownBudget",
            width: "25%",
          },
          {
            name: "Привлеченные средства, млн. руб.",
            data: "investorBudget",
            width: "25%",
            showTooltip: false,
            tooltipText:
              "Привлеченные средства, в том числе банковские кредиты, иные заемные и привлеченные средства",
          },
          {
            name: "Федеральный бюджет, млн. руб.",
            data: "federalBudget",
            width: "25%",
          },
          {
            name: "Объем отгруженной продукции, млн. руб.",
            data: "outputTotalCost",
          },
          {
            name: "Объем товарооборота, млн. руб.",
            data: "tradeTurnover",
          },
          {
            name: "Объем платных услуг (выполненных работ), млн. руб.",
            data: "serviceCost",
          },
          {
            name: "Новые рабочие места, чел.",
            data: "outputTotalWorkPlaces",
            type: "outputTotalWorkPlaces",
          },
        ];

        $scope.searching = {
          isSearch: $scope.isSearch,
          filter: null,
        };

        $scope.pagination = {
          isPaging: $scope.isPaging,
          page: 1,
          size: $scope.isPaging ? 10 : null,
          totalPages: null,
          totalItems: null,
        };

        $scope.toolbox = {
          buttons: {
            create: {
              show: () => $scope.edit,
              click: () => {
                $modal
                  .open({
                    template: require("../view/project-expected-results-modal-create.html"),
                    controller: "ProjectExpectedResultsModalCreateController",
                    size: "lg",
                    backdrop: false,
                    resolve: {
                      planFundByYear: function () {
                        return {};
                      },
                      edit: function () {
                        return $scope.edit;
                      },
                    },
                  })
                  .result.then(function (data) {
                    if (!$scope.items.some((item) => equals(item, data))) {
                      $scope.items.push(data);
                    }
                  });
              },
              disabled: () => false,
            },
            edit: {
              show: () => true,
              click: (item) => {
                $modal
                  .open({
                    template: require("../view/project-expected-results-modal-create.html"),
                    controller: "ProjectExpectedResultsModalCreateController",
                    size: "lg",
                    backdrop: false,
                    resolve: {
                      planFundByYear: function () {
                        return item;
                      },
                      edit: function () {
                        return $scope.edit;
                      },
                    },
                  })
                  .result.then(function (data) {
                    angular.copy(data, item);
                    angular.copy(data, $scope.selectedItem);
                  });
              },
              disabled: () => !isSelected(),
            },
            remove: {
              show: () => $scope.edit,
              click: (item) => {
                $scope.items.splice(
                  $scope.items.indexOf(
                    $scope.items.find((it) => equals(it, item))
                  ),
                  1
                );
                angular.copy({}, $scope.selectedItem);
              },
              disabled: () => !isSelected(),
            },
            refresh: {
              show: () => false,
              click: $scope.refresh,
              disabled: () => false,
            },
          },
        };

        refresh();

        function refresh() {
          if (Array.isArray($scope.items)) {
            if ($scope.items.every((i) => !equals(i, data))) {
              $scope.selectedItem = {};
            }
          }
        }

        function getTotal() {
          let total = 0.0;

          if (Array.isArray($scope.items)) {
            $scope.items.forEach((item) => {
              total += item.amount;
            });
          }

          return Math.round(total * 100.0) / 100.0;
        }

        function ranksDivider(num) {
          return num ? num.toLocaleString() : "";
        }

        function dblClick(item) {
          switch ($scope.type) {
            case "table":
              $scope.toolbox.buttons.edit.click(item);
              break;
            case "select":
              $scope.ok();
              break;
          }
        }

        function select(item) {
          if (!$scope.isSelect(item)) {
            $scope.selectedItem = item;
          } else {
            $scope.selectedItem = {};
          }
        }

        function isSelect(item) {
          return equals($scope.selectedItem, item);
        }

        function isSelected() {
          return (
            $scope.selectedItem != null && $scope.selectedItem.year != null
          );
        }

        function equals(i1, i2) {
          if (i1 == null || i2 == null) {
            return false;
          }

          return i1.year === i2.year;
        }

        function getItems() {
          return $scope.items;
        }
      },
    ],
  };
}
